import { z } from 'zod';

const addressSchema = {
  AddressLine1: z.string({
    required_error: 'Address is required'
  }),
  District: z.string({
    required_error: 'District is required'
  }),
  State: z.string({
    required_error: 'State is required'
  }),
  Pincode: z.string({
    required_error: 'Pincode is required'
  }).regex(/^[0-9]{6}$/, 'Must be exactly 6 digits'),
};

export const employeeSchema = z.object({
  firstName: z.string({
    required_error: 'First name is required'
  }).min(2, 'First name must be at least 2 characters'),
  
  lastName: z.string({
    required_error: 'Last name is required'
  }).min(2, 'Last name must be at least 2 characters'),
  
  email: z.string({
    required_error: 'Email is required'
  }).email('Invalid email address'),
  
  dob: z.string({
    required_error: 'Date of birth is required'
  }).refine((date) => {
    const dobDate = new Date(date);
    const today = new Date();
    const age = today.getFullYear() - dobDate.getFullYear();
    return age >= 18;
  }, "Must be at least 18 years old"),
  
  address: z.string({
    required_error: 'Address is required'
  }).min(10, 'Please provide a complete address'),
  
  // Residential Address
  residentialAddressLine1: addressSchema.AddressLine1,
  residentialDistrict: addressSchema.District,
  residentialState: addressSchema.State,
  residentialPincode: addressSchema.Pincode,
  
  // Permanent Address
  permanentAddressLine1: addressSchema.AddressLine1,
  permanentDistrict: addressSchema.District,
  permanentState: addressSchema.State,
  permanentPincode: addressSchema.Pincode,
  
  // Access Control
  accountType: z.string({
    required_error: 'Account type is required'
  }),
  role: z.string({
    required_error: 'Role is required'
  }),
  confirmRole: z.boolean({
    required_error: 'You must confirm the role',
    invalid_type_error: 'Confirmation must be checked',
  }).refine((val) => val === true, {
    message: 'You must confirm the role',
  }),
});

export const validateForm = (values) => {
  try {
    employeeSchema.parse(values);
    return {};
  } catch (error) {
    const formattedErrors = {};
    error.errors.forEach((err) => {
      formattedErrors[err.path[0]] = err.message;
    });
    return formattedErrors;
  }
};
